export default __webpack_public_path__ + "static/media/X_icon-bs.dc0af1d2.svg";